import moment from 'moment-timezone'
import { dateEST, dateViaTZ } from './injectables'
import store from './store'

/*** Will be removed after complete timezone implementation */
export const formatDate = function (value, arg1, offsetOptional) {
  if (value) {
    if (arg1 === undefined) {
      arg1 = 'MMM DD, YYYY [at] hh:mm A'
    }
    const offset = offsetOptional
      ? 0
      : moment().utcOffset(String(value))._offset
    return moment(String(value))
      .utcOffset(offset)
      .format(arg1)
  }
}

export const formatDateTZ = function (value, arg1) {
  if (value) {
    if (arg1 === undefined) {
      arg1 = 'MMM DD, YYYY [at] hh:mm A'
    }
    return moment(String(value))
      .tz(store.state.auth.preferences.time_zone)
      .format(arg1)
  }
}

export const firstCharCapital = function (value) {
  return value[0].toUpperCase() + value.substring(1)
}

export const currency = function (value, type) {
  if (typeof value !== 'number') {
    return value
  }
  if (type == 'currency') {
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
    })
    return formatter.format(value)
  } else if (type == 'currenyCent' || type == 'currencyCent') {
    if (value === 0) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      })
    } else {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      })
    }
    return formatter.format(value)
  } else if (type == 'digit') {
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 0,
    })
    return formatter.format(value)
  }
}

/**
 * Calculate time to go using timezone EST base
 * param value will be a date time format, example: 2021-01-08T06:00:59.000-05:00
 * Note: When update the user panel using timezone this need to update
 * @param {*} dateTime
 * @return String
 *  Example Outputs:
 *  seconds | less than a min to go
 *  Minutes | 10 mins to go
 *  Hours   | 10 hrs to go
 *  Days    | 2 days to go
 *  Month   | 3 mon to go
 *  Years   | 3 yrs to go
 */
/*** Will be removed after complete timezone implementation */
export const timeToGo = function (dateTime) {
  if (dateTime) {
    const timeScheduled = dateEST(dateTime).getTime()
    const now = dateEST().getTime()
    const difference = timeScheduled - now
    if (difference < 0) {} else if (difference < 60000) {
      return 'less than a min to go'
    } else if (difference > 60000 && difference < 3600000) {
      return `${Math.ceil(difference / 60000)} min${(Math.ceil(difference / 60000) !== 1) ? 's' : ''} to go`
    } else if (difference > 3600000 && difference < 86400000) {
      return `${Math.ceil(difference / 3600000)} hr${(Math.ceil(difference / 3600000) !== 1) ? 's' : ''} to go`
    } else if (difference > 86400000 && difference < 2592000000) {
      return `${Math.ceil(difference / 86400000)} day${(Math.ceil(difference / 86400000) !== 1) ? 's' : ''} to go`
    } else if (difference > 2592000000 && difference < 31536000000) {
      return `${Math.ceil(difference / 2592000000)} mon${(Math.ceil(difference / 2592000000) !== 1) ? 's' : ''} to go`
    } else {
      return `${Math.ceil(difference / 31536000000)} yr${(Math.ceil(difference / 31536000000) !== 1) ? 's' : ''} to go`
    }
  }
}

export const timeToGoTZ = function (dateTime) {
  if (dateTime) {
    const timeScheduled = dateViaTZ(dateTime).getTime()
    const now = dateViaTZ().getTime()
    const difference = timeScheduled - now
    if (difference < 0) {} else if (difference < 60000) {
      return 'less than a min to go'
    } else if (difference > 60000 && difference < 3600000) {
      return `${Math.ceil(difference / 60000)} min${(Math.ceil(difference / 60000) !== 1) ? 's' : ''} to go`
    } else if (difference > 3600000 && difference < 86400000) {
      return `${Math.ceil(difference / 3600000)} hr${(Math.ceil(difference / 3600000) !== 1) ? 's' : ''} to go`
    } else if (difference > 86400000 && difference < 2592000000) {
      return `${Math.ceil(difference / 86400000)} day${(Math.ceil(difference / 86400000) !== 1) ? 's' : ''} to go`
    } else if (difference > 2592000000 && difference < 31536000000) {
      return `${Math.ceil(difference / 2592000000)} mon${(Math.ceil(difference / 2592000000) !== 1) ? 's' : ''} to go`
    } else {
      return `${Math.ceil(difference / 31536000000)} yr${(Math.ceil(difference / 31536000000) !== 1) ? 's' : ''} to go`
    }
  }
}

export const upperCaseAfterPunctuation = function(str){
  if(str){
    return str.replace(/(^|[.!?]\s+)([a-z])/g, (match) => { return match.toUpperCase(); });
  }
}

/** 
 * This filter converts: 
 * Uppercase to lowercase and
 * Space to underscore
 */
export const toLowerCaseAndUnderscore = function(str){
  if(str){
    return str.replace(/([A-Z]+)/g, (match) => { return match.toLowerCase(); }).replace(/\s+/g, '_')
  }
}

/**
 * Removes underscore in a string and captilises all the letters in the string
 * @returns String with no underscore in it and letters capitalised
 */
 export const underscoreRemover = value => {
   if(!value) return value;
  return value
    .replaceAll("_", " ")
    .split(" ")
    .map(int => firstCharCapital(int))
    .join(" ");
};


export function calculatePercentage(numerator, denominator) {
  if (!numerator || !denominator) return 0;
  return (numerator / denominator) * 100;
}

/**
 * upperCaseFirst
 * @description capitalize the first letter of a word
 * @return {String}
 */
export const upperCaseFirst = (str) => {
  return str ? str.toString().replace(/^\w/, (c) => c.toUpperCase()) : "";
};

export const numberStatFormat = function (value, symbol='') {
  let number = 0
  if (typeof value !== 'number') {
    return value
  }
  if (value >= 1000000000) {
    number = (value / 1000000000).toFixed(1) + "B";
  } else if (value >= 1000000) {
    number = (value / 1000000).toFixed(1) + "M";
  } else if (value >= 1000) {
    number = (value / 1000).toFixed(1) + "K";
  } else {
    number = value.toString();
  }
  return `${symbol}${number}`
}